import axios from 'axios';
import router from '@/router/index.js';
import store from '@/store/index.js';

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger

    return response;
  },
  function (error) {
    const requiredAuthorization = verifyAuthentication(
      router.currentRoute.value?.meta
    );

    if (error?.response?.status === 401 && requiredAuthorization) {
      window.location.replace(window.location.origin + '/onboarding/sign-up');
    } else if ([406].includes(error?.response?.status)) {
      // A Block by the server on the user.  They need to follow
      // the URL provided in the response
      window.location.replace(error?.response?.data?.url);
    } else if (
      [401, 403, 404, 422, 429, 500].includes(error?.response?.status)
    ) {
      // Show error banner for non-excluded endpoints
      let excludedEndpoints = store.state.errors.excludedEndpoints;
      if (!excludedEndpoints?.includes(error?.response?.config?.url)) {
        store.commit('errors/setAllErrors', error?.response);
        store.commit('errors/setShowErrorBanner', true);
      }
    }
    return Promise.reject(error);
  }
);

function verifyAuthentication(auth) {
  if (auth === undefined) {
    return false;
  }
  if (auth?.doesNotRequireAuthentication) {
    return !auth.doesNotRequireAuthentication;
  }

  return false;
}

export default axios;
